import {useSessionStorage} from '@aboutyou/storage';
import {DEVICE_PARAM_TYPE} from '../features/Checkout/constants';

export const OSP_REDIRECT_KEY = 'ay-redirect-to-app';

export const useGetOSPRedirectValue = () => {
  const [device] = useSessionStorage<DEVICE_PARAM_TYPE>({
    key: OSP_REDIRECT_KEY,
    defaultValue: null,
  });

  return device;
};
